module.exports = __webpack_public_path__ + "static/media/profile-square.17399073.jpg";